export default __webpack_public_path__ + "static/media/DailyBruinLogo.36a38f7b.svg";